import React from "react";
import { APP_NAME } from "configs/AppConfig";
import { FormattedMessage, useIntl } from "react-intl";
export default function Footer() {
  const intl = useIntl();
  return (
    <footer className="footer">
      <span>
        <FormattedMessage id="copyRight" /> &copy;{" "}
        {`${new Date().getFullYear()}`}{" "}
        <span className="font-weight-semibold">{`${APP_NAME}`}</span>{" "}
        <FormattedMessage id="copyRight.text" />
      </span>

      <span>
        {`${intl.formatMessage({ id: "version" })}: ${
          process.env.REACT_APP_VERSION || "1.0.0"
        }`}
      </span>
    </footer>
  );
}
